module.exports = __webpack_public_path__ + "media/entities/3009-5173dbbf.png";